"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BorderedRadio = void 0;
var _themeGet = require("@styled-system/theme-get");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Radio = require("../Radio");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** A radio button with a border */
var BorderedRadio = (0, _styledComponents.default)(_Radio.Radio).withConfig({
  displayName: "BorderedRadio",
  componentId: "sc-1499ebf-0"
})(["padding:", ";border-radius:2px;border:1px solid ", ";transition:background-color 0.25s;&:hover:not(:disabled){background-color:", ";}&:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;}&:not(:last-child){border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0;}"], (0, _themeGet.themeGet)("space.2"), (0, _themeGet.themeGet)("colors.black10"), (0, _themeGet.themeGet)("colors.black5"));
exports.BorderedRadio = BorderedRadio;
//# sourceMappingURL=BorderedRadio.js.map